import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PipesModule } from '@jht/brand-pipes';
import { TranslateModule } from '@jht/brand-translate';

import { ContentService } from '../../../shared/content/content.service';
import { GenerateKeyPipe } from '../../shared/generate-key.pipe';
import { ProductItem } from '@src/app/shared/models/product';

@Component({
    selector: 'vision2-section-1',
    imports: [CommonModule, GenerateKeyPipe, PipesModule, TranslateModule],
    templateUrl: './section-1.component.html',
    styleUrl: './section-1.component.scss',
})
export class Section1Component implements OnChanges {
    @Input() productData: ProductItem;
    currentFeature: any;

    constructor(public contentService: ContentService) {}

    ngOnChanges(changes: SimpleChanges) {
        this.productData = changes.productData.currentValue;
        this.setActiveConsole(changes.productData.currentValue);
    }

    setActiveConsole(productData: ProductItem): void {
        this.currentFeature = productData.activeConsole?.features[0];
    }

    onFeatureClick(feature: any): void {
        this.currentFeature = feature;
    }
}
